var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 31.912,
    viewBox: "0 0 30 31.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21473",
    "data-name": "Rectangle 21473",
    width: 30,
    height: 31.912,
    transform: "translate(0 -2.946)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45437",
    "data-name": "Group 45437",
    transform: "translate(8 5.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45359",
    "data-name": "Group 45359",
    transform: "translate(-8 -2.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45360",
    "data-name": "Group 45360",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80643",
    "data-name": "Path 80643",
    d: "M8.2,1.161A13.489,13.489,0,0,1,25.434,18.393",
    transform: "translate(2.261 -1.781)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80644",
    "data-name": "Path 80644",
    d: "M20.75,18.043l-.948-4.5,4.738,1.894Z",
    transform: "translate(5.46 1.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80645",
    "data-name": "Path 80645",
    d: "M19.209,24.656A13.489,13.489,0,0,1,1.977,7.423",
    transform: "translate(0.33 2.047)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80646",
    "data-name": "Path 80646",
    d: "M3.79,4.851l.948,4.5L0,7.458Z",
    transform: "translate(0 1.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80648",
    "data-name": "Path 80648",
    d: "M8.693,15.259h.765a3.35,3.35,0,0,0,3.457,2.278c2.023,0,3.3-1.1,3.3-2.638,0-1.075-.614-2.025-2.3-2.458l-1.794-.41a3.129,3.129,0,0,1-2.893-3.1,3.362,3.362,0,0,1,3.5-3.217c.071,0,.143.009.214.017A3.344,3.344,0,0,1,16.58,8.65h-.765A2.649,2.649,0,0,0,12.942,6.5C11.227,6.5,10,7.5,10,8.88c0,1.614,1.306,2.176,2.305,2.407l1.766.41a3.242,3.242,0,0,1,2.92,3.2c0,2-1.587,3.406-4.071,3.406A4.014,4.014,0,0,1,8.693,15.259Z",
    transform: "translate(2.162 0.575)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    y2: 1.406,
    transform: "translate(15.005 5.055)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    y2: 1.61,
    transform: "translate(15.005 18.882)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.bd591d9bcd8453f4d9c9099315cfd1e0.svg";
export { ForwardRef as ReactComponent };